import type { TypeNoteChecklist, TypeNoteKind, TypeNoteMeeting, TypeNoteShape, TypeNoteTable } from '@/types/work/types.work.note';

export const NOTE_SHAPE: Record<TypeNoteKind, TypeNoteShape> = {
    note: 'text',
    map: 'map',
    model: 'code',
    endpoint: 'code',
    query: 'code',
    snippet: 'code',
    checklist: 'checklist',
    table: 'table',
    meeting: 'meeting',
};

export const EMPTY_CHECKLIST: TypeNoteChecklist = { items: [] };

export const EMPTY_TABLE: TypeNoteTable = { columns: [], rows: [] };

export const EMPTY_MEETING: TypeNoteMeeting = { heldAt: null, attendeeIds: [], decisions: [], actions: [] };
